import { render } from "./CardAtendimentos.vue?vue&type=template&id=4e6ca3aa&scoped=true&ts=true"
import script from "./CardAtendimentos.vue?vue&type=script&lang=ts"
export * from "./CardAtendimentos.vue?vue&type=script&lang=ts"

import "./CardAtendimentos.vue?vue&type=style&index=0&id=4e6ca3aa&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6ca3aa"]])

export default __exports__